<div class="outer-container">
   <div *ngIf="practiceSKeyNumber">
      <div class="practice-name-row">
         <a
            class="back-button v-greencolor"
            href="/growth-toolkit/regional-manager-summary/">
            « &nbsp;Back to Summary
         </a>
      </div>
      <div class="manager-top-row">
         <div class="growth-row-wrapper">
            <h3>{{ practiceName }}</h3>
            <div class="growth-description">
               Please review the action item(s) listed below and enable those you intend to implement. For each enabled item, enter the target value
               you aim to achieve. Once all desired action items and target values have been entered, click the
               <b>"Publish Plan"</b>
               button to submit your selections to your Regional Hospital Manager for review.
            </div>
            <!--<vc-hospital-kpi-row
      [showHospitalName]="false"
      [showMeeting]="false"
      [showChart]="true"
      [practiceSKey]="practiceSKeyNumber" />-->
            <div class="growth-meetings-block">
               <div class="growth-upcoming-meeting">
                  <a
                     *ngIf="hospitalRow?.upcomingMeetingDate"
                     href="#">
                     <h6 class="title">
                        Upcoming Meeting:
                        <span class="meeting">
                           <i class="fa fa-calendar-days"></i>
                           &nbsp;{{ hospitalRow?.upcomingMeetingDate | date : "M/d/yy | h:mm a" }}
                        </span>
                     </h6>
                  </a>
                  <h6
                     *ngIf="!hospitalRow?.upcomingMeetingDate"
                     class="title">
                     Upcoming Meeting:
                     <span class="no-meetings">No Meetings Scheduled</span>
                  </h6>
               </div>
               <div class="break">|</div>
               <div class="growth-last-meeting">
                  <h6
                     *ngIf="hospitalRow?.lastMeetingDate"
                     class="title">
                     Last Meeting:
                     <span class="meeting">
                        <i class="fa fa-calendar-days"></i>
                        &nbsp;{{ hospitalRow?.lastMeetingDate | date : "M/d/yy" }}
                     </span>
                  </h6>
                  <h6
                     *ngIf="!hospitalRow?.lastMeetingDate"
                     class="title">
                     Last Meeting:
                     <span class="no-meetings">No Previous Meetings</span>
                  </h6>
               </div>
            </div>
         </div>
         <div class="hospital-column-wrapper">
            <vc-hospital-info-column />
         </div>
      </div>

      <div class="action-row">
         <div class="action-text">
            <span class="heading">Action Items</span>
            <span class="subtext">| &nbsp;Enable the action item(s) below that you would like to roll out.</span>
         </div>
         <div class="action-buttons">
            <button
               *ngIf="actionItemList?.hasPublishedMetrics()"
               class="v-button v-button-md v-green"
               (click)="openMeetingSchedulerModal(); $event.preventDefault()">
               <i class="fa fa-calendar-days"></i>
               &nbsp; Book Appointment
            </button>
            <button
               *ngIf="!actionItemList?.hasPublishedMetrics()"
               class="v-button v-button-md v-green"
               (click)="onSaveDraftClick()">
               <i class="fa fa-save"></i>
               &nbsp; Save as Draft
            </button>
            <button
               class="v-button v-button-md v-green"
               (click)="onPublishPageClick()">
               <i class="fa fa-cloud-arrow-up"></i>
               &nbsp;
               {{ actionItemList?.hasPublishedMetrics() ? "Re-Publish Plan" : "Publish Plan" }}
            </button>
            <button
               class="v-button v-button-md v-green"
               disabled>
               <i class="fa fa-up-right-from-square"></i>
               &nbsp; View Printable Plan
            </button>
         </div>
      </div>

      <action-item-list
         #actionItemList
         [practiceSKeyNumber]="practiceSKeyNumber"
         [editable]="true" />
   </div>
   <div class="container-spacer">&nbsp;</div>
</div>
